<div class="background-deep-purple-pink bg-fixed font-oswald relative">
  <span
    class="absolute w-1/3 left-0 h-1/4 halftone bottom-11 bottom-left"
  ></span>
  <span class="absolute w-1/3 right-0 h-1/4 top-0 halftone top-right"></span>
  <div class="max-w-3xl mx-auto px-4 py-8 overflow-y-auto">
    <!-- <h2 class="text-3xl font-bold text-white text-center font-bangers">
      Changelog
    </h2>
    <h3 class="text-2xl text-white text-center mb-8">
      Features, updates and fixes to Study Heroes.
    </h3> -->

    <h2 class="text-center mt-24">
      <span
        class="text text-flat font-bangers text-6xl md:text-8xl pr-2 bg-gradient-to-r from-pink-500 to-pink-400"
        >Changelog</span
      >
    </h2>
    <h3
      class="text-4xl font-semibold tracking-tight select-none text-purple-50 text-center mb-8"
    >
      Features, updates and fixes to Study Heroes.
    </h3>

    <div class="flex justify-center mb-24">
      <button
        class="mr-4 px-4 py-2 bg-red-500 text-white shiney hover:bg-red-600 transition duration-300 ease-in-out"
        (click)="filterByPlatform('web')"
      >
        Web
      </button>
      <button
        class="mr-4 px-4 py-2 bg-green-500 text-white shiney hover:bg-green-600 transition duration-300 ease-in-out"
        (click)="filterByPlatform('android')"
      >
        Android
      </button>
      <button
        class="mr-4 px-4 py-2 bg-blue-500 text-white shiney hover:bg-blue-600 transition duration-300 ease-in-out"
        (click)="filterByPlatform('ios')"
      >
        iOS
      </button>
      <button
        class="px-4 py-2 bg-slate-200 text-slate-800 shiney hover:bg-slate-50 transition duration-300 ease-in-out"
        (click)="filterByPlatform('')"
      >
        All
      </button>
    </div>
    <div class="mb-12 changelog-entry" data-platforms="web">
      <div class="flex items-center justify-between mb-4">
        <h2 class="text-2xl font-bold text-white">v0.4.20</h2>
        <div>
          <span class="px-2 mr-4 rounded py-1 bg-red-500 text-white">Web</span>
          <span class="text-white">Mar 23, 2025</span>
        </div>
      </div>
      <div class="text-white font-lexend">
        <h3 class="text-xl font-semibold mb-3">Minor Changes</h3>
        <p>
          Restructured the file folder structures, for improved file management.
        </p>
      </div>
    </div>
    <div class="mb-12 changelog-entry" data-platforms="web">
      <div class="flex items-center justify-between mb-4">
        <h2 class="text-2xl font-bold text-white">v0.4.19</h2>
        <div>
          <span class="px-2 mr-4 rounded py-1 bg-red-500 text-white">Web</span>
          <span class="text-white">Mar 21, 2025</span>
        </div>
      </div>
      <div class="text-white font-lexend">
        <h3 class="text-xl font-semibold mb-3">Resource Remix Improvements</h3>
        <p>
          Improved the resource recording and upload functionality with new UI
          elements including progress indicators and an enhanced upload button.
        </p>
        <p>View Resource button after Creation</p>
        <p>
          Added support for language code retrieval and better resource type
          management.
        </p>
      </div>
    </div>

    <div class="mb-12 changelog-entry" data-platforms="web">
      <div class="flex items-center justify-between mb-4">
        <h2 class="text-2xl font-bold text-white">v0.4.17</h2>
        <div>
          <span class="px-2 mr-4 rounded py-1 bg-red-500 text-white">Web</span>
          <span class="text-white">Mar 19, 2025</span>
        </div>
      </div>
      <div class="text-white font-lexend">
        <h3 class="text-xl font-semibold mb-3">Various Updates</h3>
        <p>Fixed various bugs and improved the overall user experience.</p>
        <p>Included Ko-Fi link for donations.</p>
        <p>New page for Mother Tongue Education.</p>
      </div>
    </div>

    <div class="mb-12 changelog-entry" data-platforms="web">
      <div class="flex items-center justify-between mb-4">
        <h2 class="text-2xl font-bold text-white">v0.4.16</h2>
        <div>
          <span class="px-2 mr-4 rounded py-1 bg-red-500 text-white">Web</span>
          <span class="text-white">Dec 04, 2024</span>
        </div>
      </div>
      <div class="text-white font-lexend">
        <h3 class="text-xl font-semibold mb-3">Update: Profile Management</h3>
        <p>Improved the profile management to be more stateful.</p>
      </div>
    </div>

    <div class="mb-12 changelog-entry" data-platforms="android">
      <div class="flex items-center justify-between mb-4">
        <h2 class="text-2xl font-bold text-white">v0.1.00</h2>
        <div>
          <span class="px-2 mr-4 rounded py-1 bg-green-500 text-white"
            >Android</span
          >
          <span class="text-white">Dec 04, 2024</span>
        </div>
      </div>
      <div class="text-white font-lexend">
        <h3 class="text-xl font-semibold mb-3">Video and Featured Resources</h3>
        <ul class="space-y-2 mb-6 list-disc list-inside">
          <li>Video player now has full screen and playback speed controls.</li>
          <li>Home screen now has featured resources</li>
        </ul>
      </div>
    </div>

    <div class="mb-12 changelog-entry" data-platforms="web">
      <div class="flex items-center justify-between mb-4">
        <h2 class="text-2xl font-bold text-white">v0.4.15</h2>
        <div>
          <span class="px-2 mr-4 rounded py-1 bg-red-500 text-white">Web</span>
          <span class="text-white">Nov 30, 2024</span>
        </div>
      </div>
      <div class="text-white font-lexend">
        <h3 class="text-xl font-semibold mb-3">Featured Shelf Management</h3>
        <p>
          Featured shelves are now dynamicly loaded to the home screen, to
          highlight great content.
        </p>
      </div>
    </div>

    <div class="mb-12 changelog-entry" data-platforms="web">
      <div class="flex items-center justify-between mb-4">
        <h2 class="text-2xl font-bold text-white">v0.4.14</h2>
        <div>
          <span class="px-2 mr-4 rounded py-1 bg-red-500 text-white">Web</span>
          <span class="text-white">Nov 25, 2024</span>
        </div>
      </div>
      <div class="text-white font-lexend">
        <h3 class="text-xl font-semibold mb-3">Updates: Minor Bug Fixes</h3>
        <p>Better responsiveness.</p>
      </div>
    </div>

    <div class="mb-12 changelog-entry" data-platforms="android">
      <div class="flex items-center justify-between mb-4">
        <h2 class="text-2xl font-bold text-white">v0.1.00</h2>
        <div>
          <span class="px-2 mr-4 rounded py-1 bg-green-500 text-white"
            >Android</span
          >
          <span class="text-white">Nov 25, 2024</span>
        </div>
      </div>
      <div class="text-white font-lexend">
        <h3 class="text-xl font-semibold mb-3">Updates</h3>
        <p>
          With the focus on releasing a basic version of the Android app, we are
          focusing on the user flows for search and viewing resources.
        </p>
        <ul class="space-y-2 mb-6 list-disc list-inside">
          <li>Contributors</li>
          <li>Improved UI</li>
        </ul>
      </div>
    </div>

    <div class="mb-12 changelog-entry" data-platforms="web">
      <div class="flex items-center justify-between mb-4">
        <h2 class="text-2xl font-bold text-white">v0.4.13</h2>
        <div>
          <span class="px-2 mr-4 rounded py-1 bg-red-500 text-white">Web</span>
          <span class="text-white">Nov 19, 2024</span>
        </div>
      </div>
      <div class="text-white font-lexend">
        <h3 class="text-xl font-semibold mb-3">Feature: Contributors</h3>
        <p>
          This feature allows for everyone that has worked on, donated or helped
          on a resource to be acknowledged and credited. You deserve to be
          recognised for your contributions and achievements, thank you.
        </p>
        <p>
          This includes organisations and individuals that have funded the
          development of resources, thank you all.
        </p>
        <ul class="space-y-2 mb-6 list-disc list-inside">
          <li>Contributors can now be added to resources and books</li>
        </ul>
      </div>
    </div>

    <div class="mb-12 changelog-entry" data-platforms="web">
      <div class="flex items-center justify-between mb-4">
        <h2 class="text-2xl font-bold text-white">v0.4.12</h2>
        <div>
          <span class="px-2 mr-4 rounded py-1 bg-red-500 text-white">Web</span>
          <span class="text-white"> Nov 17, 2024</span>
        </div>
      </div>
      <div class="text-white font-lexend">
        <h3 class="text-xl font-semibold mb-3">Improvements</h3>
        <ul class="space-y-2 mb-6 list-disc list-inside">
          <li>Implemented Fuzzy Search</li>
          <li>Improved No Results Messages and Flow</li>
          <li>Decreased Debounce time for Search</li>
          <li>Added an All Language Per Country Option</li>
          <li>Improved Upload UX</li>
          <li>Better File Management</li>
        </ul>
      </div>
    </div>

    <div class="mb-12 changelog-entry" data-platforms="web">
      <div class="flex items-center justify-between mb-4">
        <h2 class="text-2xl font-bold text-white">v0.4.11</h2>
        <div>
          <span class="px-2 mr-4 rounded py-1 bg-red-500 text-white">Web</span>
          <span class="text-white"> Nov 10, 2024</span>
        </div>
      </div>
      <div class="text-white font-lexend">
        <h3 class="text-xl font-semibold mb-3">Improvements</h3>
        <ul class="space-y-2 mb-6 list-disc list-inside">
          <li>Total number of resources for each resource type</li>
          <li>Dynamic language list for various countries</li>
          <li>Reduced initial load time, and package size</li>
          <li>Improved searching and filtering</li>
          <li>Better resource recording compatibility for Windows and MacOS</li>
          <li>
            Users can create video recordings by clicking the record button on
            the resource details remix lessons
          </li>
          <li>Added a changelog filters for various platforms</li>
          <li>Added a staging environment for testing and deployment</li>
          <li>Improved mobile responsiveness</li>
        </ul>
      </div>
    </div>

    <div class="mb-12 changelog-entry" data-platforms="web">
      <div class="flex items-center justify-between mb-4">
        <h2 class="text-2xl font-bold text-white">v0.1.00</h2>
        <div>
          <span class="px-2 mr-4 rounded py-1 bg-red-500 text-white">Web</span>
          <span class="text-white">Oct 29, 2024</span>
        </div>
      </div>
      <div class="text-white font-lexend">
        <h3 class="text-xl font-semibold mb-3">Initial Features</h3>
        <ul class="space-y-2 mb-6 list-disc list-inside">
          <li>
            Public global search for books and resources, no login required
          </li>

          <li>Google SSO for login</li>
          <li>Logged in users can create shelves for organising resources</li>
          <li>
            Logged in users can upload resources
            <ul
              class="ml-6 mt-2 space-y-1 list-disc list-inside text-gray-200 text-sm"
            >
              <li>Rive files (.riv)</li>
              <li>PDFs (.pdf)</li>
              <li>Images (.png, .jpg, .jpeg)</li>
              <li>Videos (.mp4)</li>
              <li>Audio (.mp3)</li>
            </ul>
          </li>
          <li>
            Integrated the ability to list additional resource data to enable
            resource translations into many languages
          </li>
          <li>Logged in users can link resources to specific book pages</li>
          <li>
            Users can create video recordings by clicking the record button on
            the resource details remix lessons.
          </li>
        </ul>
        <!-- <div
          class="bg-amber-50 border-l-4 text-black p-4 border-amber-500 hidden"
        >
          <strong class="font-semibold">Known Issues:</strong>
          <ul class="list-disc list-inside space-y-2"></ul>
        </div> -->
      </div>
    </div>

    <div class="mb-12 changelog-entry" data-platforms="android">
      <div class="flex items-center justify-between mb-4">
        <h2 class="text-2xl font-bold text-white">v0.1.00</h2>
        <div>
          <span class="px-2 mr-4 rounded py-1 bg-green-500 text-white"
            >Android</span
          >
          <span class="text-white">Oct 26, 2024</span>
        </div>
      </div>
      <div class="text-white font-lexend">
        <h3 class="text-xl font-semibold mb-3">Android - Closed Testing</h3>
        <ul class="space-y-2 mb-6 list-disc list-inside">
          <li>SSO sign in</li>
          <li>Link resource to book</li>
          <li>Comment and reply on resource</li>
          <li>Create shelf</li>
          <li>Link resources to shelves</li>
          <li>Upload and create resource</li>
          <li>Content Search</li>
          <li>PDF, Video and Rive resource support</li>
          <li>Download Resource</li>
          <li>Offline Resource Viewing</li>
          <li>Google Play Store Internal Testing Setup</li>
        </ul>
      </div>
    </div>

    <div class="mb-12 changelog-entry" data-platforms="ios">
      <div class="flex items-center justify-between mb-4">
        <h2 class="text-2xl font-bold text-white">v0.1.00</h2>
        <div>
          <span class="px-2 mr-4 rounded py-1 bg-blue-500 text-white">iOS</span>
          <span class="text-white">Planned Release: TBA</span>
        </div>
      </div>
      <div class="text-white font-lexend">
        <h3 class="text-xl font-semibold mb-3">iOS - Closed Testing</h3>
        <ul class="space-y-2 mb-6 list-disc list-inside">
          <li>SSO sign in</li>
          <li>Link resource to book</li>
          <li>Comment and reply on resource</li>
          <li>Create shelf</li>
          <li>Link resources to shelves</li>
          <li>Upload and create resource</li>
          <li>Content Search</li>
          <li>PDF, Video and Rive resource support</li>
        </ul>

        <div class="bg-amber-50 border-l-4 text-black p-4 border-amber-500">
          <strong class="font-semibold">Note:</strong>
          We are planning to release the iOS version, we are still in the still
          in the process of raising funds to support this venture.
        </div>
      </div>
    </div>
  </div>
</div>
